import { cn } from '@/lib/utils'
import type { FontAwesomeIcon, IconType } from '@ur-solutions/react-components'
import type { CSSProperties, HTMLAttributes, MouseEventHandler } from 'react'

export interface FAIconProps {
  className?: string
  style?: CSSProperties

  icon: FontAwesomeIcon
  type?: IconType

  cursor?: CSSProperties['cursor']
  fixedWidth?: boolean
  disabled?: boolean
  role?: HTMLAttributes<HTMLElement>['role']

  onClick?: MouseEventHandler<HTMLElement>
}

export function FAIcon({
  className,
  style,

  icon,
  type = 'regular',

  cursor,
  fixedWidth = false,
  disabled = false,
  role,

  onClick,
}: FAIconProps) {
  return (
    <i
      className={cn(`fa-${type} fa-${icon}`, fixedWidth && 'fa-fw', className)}
      style={{ cursor, ...style }}
      aria-hidden="true"
      role={role}
      onClick={evt => !disabled && onClick?.(evt)}
    />
  )
}
